<template>
  <div class="floor-video-ad-components clearfix">
    <div class="floor-ad">
      <el-carousel trigger="click" height="388px" arrow="never">
        <el-carousel-item v-for="(banner, index) in bannerList" :key="index">
          <a class="ad-item" :href="banner.url" target="_blank">
            <span class="ad-text" v-if="bannerTextShow">{{banner.name}}</span>
            <img :src="imageHost(banner.filedPath, banner.templatePath)" alt="" class="image">
          </a>
        </el-carousel-item>
      </el-carousel>
    </div>
    <div class="floor-video clearfix">
      <div class="video-item" v-for="(video, index) in videoList" :key="index">
        <floor-video-item :video="video" :blueBG="blueBG"/>
      </div>
    </div>
  </div>
</template>

<script>
import FloorVideoItem from '@/components/cloud/FloorVideoItem'
import { fileHost } from '@/assets/js/api/cloud'

export default {
  name: 'FloorVideoAD',
  components: { FloorVideoItem },
  props: {
    floor: {
      type: Array,
      default () {
        return []
      },
    },
    index: {
      type: Number,
      default: 0,
    },
  },
  data () {
    return {
      bannerTextShow: false,
    }
  },
  computed: {
    bannerList () {
      const bannerList = this.floor.filter((item, index) => !item.isVideo)
      return bannerList.filter((item, index) => index < 5)
    },
    videoList () {
      const videoList = this.floor.filter((item, index) => item.isVideo)
      return videoList.filter((item, index) => index < 8)
    },
    // 蓝色底返回green
    blueBG () {
      if (this.index % 2 !== 0) {
        return (this.index + 1) % 4 === 0 ? 'blue' : 'green'
      } else {
        return (this.index + 2) % 4 === 0 ? 'green' : 'blue'
      }
    },
  },
  mounted () {
    this.getImportCss()
  },
  methods: {
    // 动态加载字体CSS
    getImportCss () {
      const vm = this
      const cssNode = document.createElement('link')
      cssNode.rel = 'stylesheet'
      cssNode.type = 'text/css'
      cssNode.href = `${process.env.BASE_URL === '/' ? '' : process.env.BASE_URL}/fonts.css`
      cssNode.onload = function () {
        vm.bannerTextShow = true // 字体加载完成后再显示需要用特殊字体的文字
      }
      document.getElementsByTagName('head')[0].appendChild(cssNode)
    },
    // 广告图片地址
    imageHost (fileUrl, templateUrl) {
      if (fileUrl) {
        return fileUrl
      }
      return fileHost() + templateUrl.replace(/\\/g, '/')
    },
  },
}
</script>

<style lang="scss">
.floor-video-ad-components {
  margin-top: 26px;
  width: 100%;

  .floor-ad {
    float: left;
    margin-right: 20px;
    width: 224px;
    height: 388px;

    .ad-item {
      display: block;
      position: relative;
      width: 100%;
      height: 100%;
      padding: 100px 22px 0 22px;
      box-sizing: border-box;

      .image {
        position: absolute;
        top: 0;
        left: 0;
        z-index: 0;
        width: 100%;
        height: 100%;
      }

      .ad-text {
        position: relative;
        z-index: 1;
        font-size: 30px;
        color: #fff;
        font-family: ADFONTS;
      }
    }
  }

  .floor-video {
    float: left;
    width: 956px;
    height: 388px;

    .video-item {
      float: left;
      margin-right: 20px;
      width: 224px;

      &:nth-child(4n) {
        margin-right: 0;
      }

      &:nth-child(n+5) {
        margin-top: 30px;
      }
    }
  }
}
</style>
